(function personaModule(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  const previousPersonaModule = global.NewHomeSource.Persona;
  const pendingEvent = JSON.parse(localStorage.getItem('pendingAutenticationEvent'));
  const idleQueue = new global.NewHomeSource.Modules.IdleQueue();

  /**
   * shouldAddEventToQueue: when lastSavedItemTime is 0, it means that is the first time
   * user login in the NHS.
   */
  let shouldAddEventToQueue = !(+global.localStorage.getItem('lastSavedItemTime'));
  /**
   * isRequestToSegmentApiEnded: to avoid override 5 favorites saved by the user without login
   * this variable tell to idleQueue is secure moment to send events to segment API.
   */
  let isRequestToSegmentApiEnded = false;

  /**
   * @private
   * clean the local storage data
   */
  function cleanLocalStorage() {
    localStorage.setItem('saved_communities', JSON.stringify({ saved_communities: [] }));
    localStorage.setItem('saved_builders', JSON.stringify({ saved_builders: [] }));
    localStorage.setItem('saved_homes', JSON.stringify({ saved_homes: [] }));
    global.localStorage.setItem('lastSavedItemTime', '');
  }

  /**
   * @private
   * create a object with the dataset information
   * @param {object} dataset data attributes from dom element
   */
  function createSaveItemObject(dataset) {
    const type = dataset.type;
    const device = window.NewHomeSource.Modules.tagManager.getFromDataLayer('adaptiveTemplate');
    const date = new Date();
    const format = function (number) { return number < 10 ? '0' + number : number; };
    const objectToSave = {
      builderId: dataset.builder,
      source: device !== null && device === 'M' ? 'Mobile Web' : 'Web',
      date_saved: format(date.getMonth() + 1) + '/' + format(date.getDate()) + '/' + date.getFullYear(),
    };

    if (type !== 'Builder') {
      objectToSave.communityId = dataset.community;

      if (type === 'HomePlan') {
        objectToSave.planId = dataset.planId;
      }
      if (type === 'HomeSpec') {
        objectToSave.specId = dataset.specId;
      }
    }

    return objectToSave;
  }

  /**
   * @private
   * get the key from local storage data
   * @param {string} type string
   */
  function getLocalStorageKeyValue(type) {
    const dataType = {
      homespec: 'saved_homes',
      homeplan: 'saved_homes',
      community: 'saved_communities',
      builder: 'saved_builders'
    };

    const key = dataType[type.toLowerCase()];
    if (!key) {
      return null;
    }

    return key;
  }

  /**
   * @private
   * get the index of element (object) inside to the array
   * @param {object} arrayObjects array of element (object)
   * @param {object} elementToFind object
   * @param {string} type string
   */
  function getIndexIfExist(arrayObjects, elementToFind, type) {
    if (!arrayObjects || !elementToFind || !type) {
      return -1;
    }

    const dataType = {
      homespec: 'specId',
      homeplan: 'planId',
      community: 'communityId',
      builder: 'builderId'
    };

    const consult = dataType[type.toLowerCase()];
    if (!consult) {
      return -1;
    }

    for (let index = 0; index < arrayObjects.length; index += 1) {
      if (arrayObjects[index][consult] === elementToFind[consult]) {
        return index;
      }
    }

    return -1;
  }

  /**
   * @private
   * remove or add element(object) in some array
   * @param {object} arrayObjects array
   * @param {object} elementSaveItem element to find
   * @param {string} isRemove string
   * @param {string} type string
   */
  function updateArrayObject(arrayObjects, elementSaveItem, isRemove, type) {
    if (!arrayObjects || !elementSaveItem || !type) {
      return [];
    }
    const index = getIndexIfExist(arrayObjects, elementSaveItem, type);
    const exist = index > -1;

    if (isRemove && exist) {
      arrayObjects.splice(index, 1);
    }
    if (!isRemove && !exist) {
      arrayObjects.push(elementSaveItem);
    }

    return arrayObjects;
  }

  /**
   * @private
   * get the object with the element array to save in local storage
   * @param {object} element Dom element with the data attributes required
   * @param {string} isRemove data attribute
   */
  function getItemsToBeSaved(element, isRemove) {
    if (!element) {
      return {};
    }

    const elementSaveItem = createSaveItemObject(element.dataset);
    const keyLocalStorage = getLocalStorageKeyValue(element.dataset.type);

    const localSavedItems = JSON.parse(localStorage.getItem(keyLocalStorage));

    if (!localSavedItems[keyLocalStorage]) {
      localSavedItems[keyLocalStorage] = [];
    }

    const arrayObjects = localSavedItems[keyLocalStorage];
    const arrayObjectsUpdated = updateArrayObject(arrayObjects, elementSaveItem, isRemove, element.dataset.type);

    localSavedItems[keyLocalStorage] = arrayObjectsUpdated;
    return localSavedItems;
  }

  /**
   * @private
   * set in local storage the favorites element list
   * @param {object} element Dom element with the data attributes required
   */
  function updateLocalStorage(element) {
    if (!element) {
      return {};
    }

    const keyLocalStorage = getLocalStorageKeyValue(element.dataset.type);
    const itemsToUpdate = getItemsToBeSaved(element, element.dataset.removeLocalStorage);

    localStorage.setItem(keyLocalStorage, JSON.stringify(itemsToUpdate));

    return itemsToUpdate;
  }

  function getLastEvent(type, isRemove) {
    const dataTypes = {
      homespec: isRemove ? 'Home Removed' : 'Home Saved',
      homeplan: isRemove ? 'Home Removed' : 'Home Saved',
      community: isRemove ? 'Community Removed' : 'Community Saved',
      builder: isRemove ? 'Builder Removed' : 'Builder Saved',
    };

    const lastEvent = dataTypes[type.toLowerCase()];
    if (!lastEvent) {
      return 'Save Item';
    }

    return lastEvent;
  }

  /**
   * saveItems: sava data in storage.
   *
   * @param {object} data to save.
   */
  function saveItems(data) {
    const updatedItem = updateLocalStorage(data);
    const eventForSegment = {
      event: getLastEvent(data.dataset.type, data.dataset.removeLocalStorage),
      eventType: 'segmentEvent',
      isIdentifyEvent: true,
      isIdentifyOnly: true,
    };

    const key = Object.keys(updatedItem)[0];
    eventForSegment[key] = updatedItem[key];
    document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
      detail: { data: eventForSegment }
    }));
  }

  /**
   * updateLastSavedItem: update the time of last saved item in storage.
   */
  function updateLastSavedItem() {
    global.localStorage.setItem('lastSavedItemTime', +new Date());
  }

  /**
   * shouldGetSegmentProfile: should update the data with API segment profile
   *
   * @returns True when first favorite element is saved/removed, and elapsed 30s, otherwise false
   */
  function shouldGetSegmentProfile() {
    const lastItemSavedTime = +global.localStorage.getItem('lastSavedItemTime');
    updateLastSavedItem();
    const actualDate = +new Date();

    if (!lastItemSavedTime || actualDate - lastItemSavedTime > 30000) {
      return true;
    }

    return false;
  }

  /**
   * getSegmentProfile: get segment profile data from API.
   *
   * @param {String} id user to request the data.
   */
  async function getSegmentProfile(id) {
    const urlForSegmentApi = '/getsegmentprofile?userId=' + id;
    const response = await fetch(urlForSegmentApi, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (response.ok) {
      const data = await response.json();
      return JSON.parse(data);
    }
    return null;
  }

  /**
  * @private
  * getUserId: get user id from coockies
  *
  */
  function getUserId() {
    const userId = global.NewHomeSource.Modules.cookieHandler.readCookie('Profile', true);

    if (userId) {
      return userId.replace('{', '').replace('}', '');
    }

    return userId;
  }

  /**
   * @private
   * handlerQueue: function push to idleQueue tasks
   * If the request to segment has ended store the value and return true to avoid loop task.
   * Otherwise return false to execute the task later.
   *
   * @returns {boolean} value to see if task will continue.
   */
  function handlerQueue() {
    if (isRequestToSegmentApiEnded) {
      saveItems(this);
      return true;
    }

    return false;
  }

  /**
   * stopAddEventsToQueue: when the first request to server after user login we doesn't need to
   * add more events to queue.
   */
  function stopAddEventsToQueue() {
    isRequestToSegmentApiEnded = true;
    shouldAddEventToQueue = false;
  }

  /**
  * @private
  * trackIdentifySaveItems: track saved items for identify profile.
  *
  * @param {object} e event triggered with the on demand data to track.
  */
  async function trackIdentifySaveItems(e) {
    if (!e.detail.data) {
      return;
    }

    if (shouldGetSegmentProfile()) {
      const userId = getUserId();
      const data = await getSegmentProfile(userId);
      if (data) {
        // eslint-disable-next-line no-use-before-define
        savePreferencesInLocalStorage(data);
      }
      stopAddEventsToQueue();
      saveItems(e.detail.data);
      return;
    }

    if (shouldAddEventToQueue) {
      idleQueue.pushTask(handlerQueue.bind(e.detail.data));
      return;
    }

    saveItems(e.detail.data);
  }

  /**
  * @private
  * getLastLoggedInData: try gets the LastLoggedInData cookie.
  *
  */
  function getLastLoggedInData() {
    const lastLoggedInData = document.cookie.match(/LastLoggedInData_[0-9]=([^;]+)/);

    if (!lastLoggedInData) {
      return null;
    }

    return lastLoggedInData[0].split('=');
  }

  /**
  * @private
  * savePreferencesInLocalStorage: creates local storage objects for saved items.
  *
  * @param {object} personaInformation with the items to save in local storage.
  */
  function savePreferencesInLocalStorage(personaInformation) {
    if (!personaInformation && !pendingEvent) {
      document.body.removeEventListener('trackIdentifySaveItems', trackIdentifySaveItems);
      return;
    }

    const persona = personaInformation || {};

    persona.traits = persona.traits || {};
    persona.traits.saved_communities = persona.traits.saved_communities || [];
    persona.traits.saved_homes = persona.traits.saved_homes || [];
    persona.traits.saved_builders = persona.traits.saved_builders || [];
    const savedCommunities = JSON.parse(localStorage.getItem('saved_communities'));
    if (savedCommunities === null ||
      !Array.isArray(savedCommunities.saved_communities) || savedCommunities.saved_communities.length === 0 ||
      persona.traits.saved_communities) {
      localStorage.setItem('saved_communities', JSON.stringify(
        { saved_communities: persona.traits.saved_communities }
      ));
    }

    const savedHomes = JSON.parse(localStorage.getItem('saved_homes'));
    if (savedHomes === null ||
      !Array.isArray(savedHomes.saved_homes) || savedHomes.saved_homes.length === 0 ||
      persona.traits.saved_homes) {
      localStorage.setItem('saved_homes', JSON.stringify(
        { saved_homes: persona.traits.saved_homes }
      ));
    }

    const savedBuilders = JSON.parse(localStorage.getItem('saved_builders'));
    if (savedBuilders === null ||
      !Array.isArray(savedBuilders.saved_builders) || savedBuilders.saved_builders.length === 0 ||
      persona.traits.saved_builders) {
      localStorage.setItem('saved_builders', JSON.stringify(
        { saved_builders: persona.traits.saved_builders }
      ));
    }

    const lastLoggedInData = getLastLoggedInData();
    if (lastLoggedInData) {
      document.cookie = [lastLoggedInData[0], '=', 'false', '; domain=.',
        `${global.location.host.toString().split('.')[1]}.com`, '; path=/;'].join('');
    }
  }

  /**
  * @private
  * postPendingAutenticationEvent: enqueues pending autentication events in local storage.
  */
  function postPendingAutenticationEvent() {
    if (!pendingEvent) {
      return;
    }

    localStorage.removeItem('pendingAutenticationEvent');

    document.body.dispatchEvent(new CustomEvent(
      'trackOnDemandEvent',
      {
        detail: { data: pendingEvent }
      }
    ));
  }

  /**
  * @private
  * onPageLoad: function to be executed on page load event.
  */
  function onPageLoad() {
    if (!window.NewHomeSource.UserCredentials.isUserLogged()) {
      cleanLocalStorage();
    }

    postPendingAutenticationEvent();
  }

  /**
  * @constructs NewHomeSource.Persona
  */
  function Persona() {
    global.window.addEventListener('load', onPageLoad);
    document.body.addEventListener('trackIdentifySaveItems', trackIdentifySaveItems);
  }

  /**
  * @public
  *
  * noConflict: Returns control of NewHomeSource.Persona to the previous script.
  */
  Persona.noConflict = function noConflict() {
    global.NewHomeSource.Persona = previousPersonaModule;
    return Persona;
  };
  global.NewHomeSource.Persona = Persona;

  Persona();
}(window));
